export default __webpack_public_path__ + "static/media/17.8db8cdc9.png";